import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { CrearUsuarioComponent } from './CrearUsuario.component';
import { CrearPerfilComponent } from './CrearPerfil.component';
import { UsuarioIndexComponent } from './UsuarioIndex.component';
import { CrearPerfilIndexComponent } from './CrearPerfilIndex.component';
import { AsignarContratoUsuarioComponent } from './AsignarContratoUsuarioIndex.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';




const routes = [
    {
        path     : 'CrearUsuario',
        component: CrearUsuarioComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CrearUsuario',
          nombreFormulario : 'Crear Usuario'
        } 
    },{
        path     : 'CrearUsuario/:cusuario/:cnumid',
        component: CrearUsuarioComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CrearUsuario',
          nombreFormulario : 'Editar Usuario'
        } 
    },{
        path     : 'CrearPerfil',
        component: CrearPerfilComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CrearPerfil',
          nombreFormulario : 'Crear Perfil'
        } 
    },{
        path     : 'CrearPerfil/:nidrol/:cdescriprol',
        component: CrearPerfilComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CrearPerfil',
          nombreFormulario : 'Editar Perfil'
        } 
    },{
        path     : 'UsuarioIndex',
        component: UsuarioIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'UsuarioIndex',
          nombreFormulario : 'Usuarios'
        } 
    },{
        path     : 'CrearPerfilIndex',
        component: CrearPerfilIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CrearPerfilIndex',
          nombreFormulario : 'Perfiles'
        } 
    },{
    path     : 'AsignarContrato/usuario/:cusuario/:ciddoc',
    component: AsignarContratoUsuarioComponent,
    canActivate: [RoleGuard], 
    data: { 
        formulario: 'CrearUsuario',
        nombreFormulario : 'Asignar contarto a usuario'
    } 
}
];

@NgModule({
    declarations: [
        CrearUsuarioComponent,
        CrearPerfilComponent,
        UsuarioIndexComponent,
        CrearPerfilIndexComponent,
        AsignarContratoUsuarioComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CrearUsuarioComponent,
        CrearPerfilComponent,
        UsuarioIndexComponent,
        CrearPerfilIndexComponent,
        AsignarContratoUsuarioComponent
    ]
})

export class AdministracionUsuariosModule
{
}




// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/AdministracionUsuarios/AdministracionUsuarios.module.ts